import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';

import { UserPermission } from '../user/user.service';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    isLoading = new Subject<boolean>();
    // isSideBarExpanded = new Subject<boolean>();
    // sidebarVisible = new Subject<boolean>();

    //readonly NO_HEADER_ROUTES = ['/auth/signup', '/auth/login', '/auth/forget-password', '/auth/reset'];

    sideBarItems: MenuItem[] = [
        // {
        //     icon: 'material-icons mi-home',
        //     routerLink: '/pages/home',
        //     label: 'home.title',
        //     visible: true
        // },
        // {
        //     icon: 'material-icons mi-dashboard',
        //     routerLink: '/pages/dashboard',
        //     label: 'dashboard.title',
        //     visible: true
        // },
        // {
        //     icon: 'material-icons mi-bar-chart',
        //     routerLink: '/pages/explore',
        //     label: 'explore.title',
        //     visible: true
        // },
        {
            icon: 'material-icons mi-settings',
            routerLink: '/pages/admin',
            label: 'administrator.title',
            visible: true
        },
        {
            icon: 'material-icons mi-support-agent',
            routerLink: '/pages/support',
            label: 'support.title',
            visible: true
        },

        {
            icon: 'pi pi-bell',
            routerLink: '/pages/smartips-news',
            label: 'smartips-news.title',
            visible: true
        },
        {
            icon: 'pi pi-file-import',
            routerLink: '/pages/user-app-guide',
            label: 'user-app-guide.title',
            visible: true
        }
    ];

    show() {
        this.isLoading.next(true);
    }

    hide() {
        this.isLoading.next(false);
    }

    getSidebarItemsByRole(userRoles: { id: number; name: string }[] | undefined): MenuItem[] {
        if (!userRoles || userRoles.length === 0) {
            return this.sideBarItems;
        }
        const isOnlySupport = userRoles.length === 1 && userRoles.some((role) => role.id === 6 || role.id === 7);

        if (isOnlySupport) {
            return this.sideBarItems.filter((item) => item.routerLink === '/pages/support');
        }

        return this.sideBarItems;
    }
}
